import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { AlertContext } from "../../context/AlertContext";
import Spinner from "./Spinner";
import { AuthContext } from "../../context/AuthContext";
import { ServiciosContext } from "../../context/ServiciosContext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonUnstyled from "@mui/base/ButtonUnstyled";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import FormControlLabel from "@mui/material/FormControlLabel";
import ButtonMui from "@mui/material/Button";
import { Navigate, useNavigate } from "react-router-dom";
import Menu from "./Menu";
import { saveAs } from "file-saver";
import Autocomplete from "@mui/material/Autocomplete";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Typography from "@mui/material/Typography";

export default function Yesavage(props) {
  let navigate = useNavigate();

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const serviciosContext = useContext(ServiciosContext);
  const {
    yesavage,
    statusAcceso3,
    statusAcceso4,
    localidades,
    guardarYesavage,
    obtenerAcceso3,
    obtenerAcceso4,
  } = serviciosContext;

  useEffect(() => {
    obtenerAcceso4({
      usuarioId: state.usuario.id,
      layout: "Psicologia",
    });
    obtenerAcceso3({
      usuarioId: state.usuario.id,
      layout: "EditarPIHC",
    });
  }, []);

  const handleChangePregunta1 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta1: event.target.value,
    });
  };

  const handleChangePregunta2 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta2: event.target.value,
    });
  };

  const handleChangePregunta3 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta3: event.target.value,
    });
  };

  const handleChangePregunta4 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta4: event.target.value,
    });
  };

  const handleChangePregunta5 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta5: event.target.value,
    });
  };

  const handleChangePregunta6 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta6: event.target.value,
    });
  };

  const handleChangePregunta7 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta7: event.target.value,
    });
  };

  const handleChangePregunta8 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta8: event.target.value,
    });
  };

  const handleChangePregunta9 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta9: event.target.value,
    });
  };

  const handleChangePregunta10 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta10: event.target.value,
    });
  };

  const handleChangePregunta11 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta11: event.target.value,
    });
  };

  const handleChangePregunta12 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta12: event.target.value,
    });
  };

  const handleChangePregunta13 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta13: event.target.value,
    });
  };

  const handleChangePregunta14 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta14: event.target.value,
    });
  };

  const handleChangePregunta15 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta15: event.target.value,
    });
  };

  const handleChangePregunta16 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta16: event.target.value,
    });
  };

  const handleChangePregunta17 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta17: event.target.value,
    });
  };

  const handleChangePregunta18 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta18: event.target.value,
    });
  };

  const handleChangePregunta19 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta19: event.target.value,
    });
  };

  const handleChangePregunta20 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta20: event.target.value,
    });
  };

  const handleChangePregunta21 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta21: event.target.value,
    });
  };

  const handleChangePregunta22 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta22: event.target.value,
    });
  };

  const handleChangePregunta23 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta23: event.target.value,
    });
  };

  const handleChangePregunta24 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta24: event.target.value,
    });
  };

  const handleChangePregunta25 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta25: event.target.value,
    });
  };

  const handleChangePregunta26 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta26: event.target.value,
    });
  };

  const handleChangePregunta27 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta27: event.target.value,
    });
  };

  const handleChangePregunta28 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta28: event.target.value,
    });
  };

  const handleChangePregunta29 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta29: event.target.value,
    });
  };

  const handleChangePregunta30 = (event) => {
    guardarYesavage({
      ...yesavage,
      pregunta30: event.target.value,
    });
  };

  //console.log(paciente);
  //console.log(yesavage);

  return (
    <Fragment>
      {yesavage ? (
        <Fragment>
          <Grid
            container
            spacing={3}
            style={{ marginTop: "0vw", marginLeft: "0vw" }}
          >
            <Grid item xs={12} md={6}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta1 : null}
                  onChange={handleChangePregunta1}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (1) - ¿En el fondo está satisfecho con su vida?
                  </FormLabel>

                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta2 : null}
                  onChange={handleChangePregunta2}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (2) - ¿Ha abandonado muchas de sus actividades y
                    pasatiempos?
                  </FormLabel>

                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta3 : null}
                  onChange={handleChangePregunta3}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (3) - ¿Siente que su vida está vacía?
                  </FormLabel>

                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta4 : null}
                  onChange={handleChangePregunta4}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (4) - ¿Se aburre con frecuencia?
                  </FormLabel>

                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta5 : null}
                  onChange={handleChangePregunta5}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (5) - ¿Tiene esperanza en el futuro?
                  </FormLabel>

                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta6 : null}
                  onChange={handleChangePregunta6}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (6) - ¿Le preocupan ideas que no pueda quitar de su cabeza?
                  </FormLabel>

                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta7 : null}
                  onChange={handleChangePregunta7}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (7) - ¿Se encuentra de buen ánimo la mayor parte del tiempo?
                  </FormLabel>

                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta8 : null}
                  onChange={handleChangePregunta8}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (8) - ¿Teme que algo malo pueda sucederle?
                  </FormLabel>

                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta9 : null}
                  onChange={handleChangePregunta9}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (9) - ¿Se siente feliz la mayor parte del tiempo?
                  </FormLabel>

                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta10 : null}
                  onChange={handleChangePregunta10}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (10) - ¿Se siente desamparado con frecuencia?
                  </FormLabel>

                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta11 : null}
                  onChange={handleChangePregunta11}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (11) - ¿Con frecuencia se siente desvelado y nervioso?
                  </FormLabel>

                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta12 : null}
                  onChange={handleChangePregunta12}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (12) - ¿Prefiere quedarse en casa a salir y realizar cosas
                    nuevas?
                  </FormLabel>

                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta13 : null}
                  onChange={handleChangePregunta13}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (13) - ¿Se preocupa con frecuencia por el futuro?
                  </FormLabel>

                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta14 : null}
                  onChange={handleChangePregunta14}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (14) - ¿Piensa que tiene menos memoria que el resto de la
                    gente?
                  </FormLabel>

                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta15 : null}
                  onChange={handleChangePregunta15}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (15) - ¿Piensa que es bueno estar vivo hoy?
                  </FormLabel>

                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta16 : null}
                  onChange={handleChangePregunta16}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (16) - ¿Se siente triste y desanimado con frecuencia?
                  </FormLabel>

                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta17 : null}
                  onChange={handleChangePregunta17}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (17) - ¿Se siente inútil en su estado actual?
                  </FormLabel>

                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta18 : null}
                  onChange={handleChangePregunta18}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (18) - ¿Se preocupa mucho por el pasado?
                  </FormLabel>

                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta19 : null}
                  onChange={handleChangePregunta19}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (19) - ¿Le parece que la vida es algo apasionante?
                  </FormLabel>

                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta20 : null}
                  onChange={handleChangePregunta20}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (20) - ¿Le cuesta mucho emprender nuevos proyectos?
                  </FormLabel>

                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta21 : null}
                  onChange={handleChangePregunta21}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (21) - ¿Se siente con energías?
                  </FormLabel>

                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta22 : null}
                  onChange={handleChangePregunta22}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (22) - ¿Piensa que su situación no tiene arreglo?
                  </FormLabel>

                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta23 : null}
                  onChange={handleChangePregunta23}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (23) - ¿Piensa que la mayor parte de la gente está mejor que
                    usted?
                  </FormLabel>

                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta24 : null}
                  onChange={handleChangePregunta24}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (24) - ¿Se disgusta con frecuencia por cosas sin
                    importancia?
                  </FormLabel>

                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta25 : null}
                  onChange={handleChangePregunta25}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (25) - ¿Siente ganas de llorar frecuentemente?
                  </FormLabel>

                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta26 : null}
                  onChange={handleChangePregunta26}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (26) - ¿Tiene dificultad para concentrarse?
                  </FormLabel>

                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta27 : null}
                  onChange={handleChangePregunta27}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (27) - ¿Disfruta al levantarse de mañana?
                  </FormLabel>

                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta28 : null}
                  onChange={handleChangePregunta28}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (28) - ¿Prefiere evitar las reuniones sociales?
                  </FormLabel>

                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta29 : null}
                  onChange={handleChangePregunta29}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (29) - ¿Le resulta fácil tomar decisiones?
                  </FormLabel>

                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} style={{ marginTop: "-2vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={yesavage ? yesavage.pregunta30 : null}
                  onChange={handleChangePregunta30}
                >
                  <FormLabel
                    id="escalones"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    (30) - ¿Siente su mente tan despejada como antes?
                  </FormLabel>

                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="SI"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="NO"
                    disabled={
                      (yesavage && yesavage.status && statusAcceso3 !== 200) ||
                      (yesavage && !yesavage.status && statusAcceso4 !== 200)
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={4}>
              <Typography variant="h5" gutterBottom component="div">
                Resultado
              </Typography>
              <Typography variant="h4" gutterBottom component="div">
                {Number(yesavage.pregunta1 ? yesavage.pregunta1 : 0) +
                  Number(yesavage.pregunta2 ? yesavage.pregunta2 : 0) +
                  Number(yesavage.pregunta3 ? yesavage.pregunta3 : 0) +
                  Number(yesavage.pregunta4 ? yesavage.pregunta4 : 0) +
                  Number(yesavage.pregunta5 ? yesavage.pregunta5 : 0) +
                  Number(yesavage.pregunta6 ? yesavage.pregunta6 : 0) +
                  Number(yesavage.pregunta7 ? yesavage.pregunta7 : 0) +
                  Number(yesavage.pregunta8 ? yesavage.pregunta8 : 0) +
                  Number(yesavage.pregunta9 ? yesavage.pregunta9 : 0) +
                  Number(yesavage.pregunta10 ? yesavage.pregunta10 : 0) +
                  Number(yesavage.pregunta11 ? yesavage.pregunta11 : 0) +
                  Number(yesavage.pregunta12 ? yesavage.pregunta12 : 0) +
                  Number(yesavage.pregunta13 ? yesavage.pregunta13 : 0) +
                  Number(yesavage.pregunta14 ? yesavage.pregunta14 : 0) +
                  Number(yesavage.pregunta15 ? yesavage.pregunta15 : 0) +
                  Number(yesavage.pregunta16 ? yesavage.pregunta16 : 0) +
                  Number(yesavage.pregunta17 ? yesavage.pregunta17 : 0) +
                  Number(yesavage.pregunta18 ? yesavage.pregunta18 : 0) +
                  Number(yesavage.pregunta19 ? yesavage.pregunta19 : 0) +
                  Number(yesavage.pregunta20 ? yesavage.pregunta20 : 0) +
                  Number(yesavage.pregunta21 ? yesavage.pregunta21 : 0) +
                  Number(yesavage.pregunta22 ? yesavage.pregunta22 : 0) +
                  Number(yesavage.pregunta23 ? yesavage.pregunta23 : 0) +
                  Number(yesavage.pregunta24 ? yesavage.pregunta24 : 0) +
                  Number(yesavage.pregunta25 ? yesavage.pregunta25 : 0) +
                  Number(yesavage.pregunta26 ? yesavage.pregunta26 : 0) +
                  Number(yesavage.pregunta27 ? yesavage.pregunta27 : 0) +
                  Number(yesavage.pregunta28 ? yesavage.pregunta28 : 0) +
                  Number(yesavage.pregunta29 ? yesavage.pregunta29 : 0) +
                  Number(yesavage.pregunta30 ? yesavage.pregunta30 : 0)}
              </Typography>
            </Grid>
          </Grid>
        </Fragment>
      ) : (
        <Spinner />
      )}
      <Grid item xs={12} sm={12}></Grid>
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
